<template>
    <app-layout>
      <Head title="Dashboard"/>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>
        <div class="max-w-7xl mx-auto">
            <div class="w-full p-2 sm:px-6 lg:px-8 mb-3 lg:mb-4">
                <div class="flex flex-col lg:flex-row lg:items-stretch lg:space-x-4">
                    <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 lg:py-7 lg:flex-1">
                        <organization-info-box></organization-info-box>
                    </div>
                    <div class="mt-3 lg:mt-0 lg:w-80">
                        <div class="bg-white shadow-xl sm:rounded-lg p-5 sm:p-6 lg:p-7 flex flex-col h-full border border-gray-100">
                            <p class="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">
                                Product Roadmap
                            </p>
                            <p class="text-sm text-gray-600 leading-relaxed mb-6 flex-1">
                                What we're building next + what we're exploring. Provide your feedback to elevate priority.
                            </p>
                            <a
                                href="https://textspot.io/product-roadmap/"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="inline-flex items-center justify-center px-4 py-2 bg-gray-100 text-gray-700 font-semibold text-xs uppercase tracking-widest rounded-md transition hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                            >
                                Visit Roadmap
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full p-2 sm:px-6 lg:px-8 pb-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">
                        Send A Message
                    </h2>
                  <div
                    v-if="!$page.props.subscribed && $page.props.is_admin"
                    class="mt-2 mb-4"
                  >
                    <p v-if="!$page.props.submitted_a2p" class="font-italic text-sm mb-3 md:mr-4 md:mb-0">
                        <span class="font-bold">
                            After selecting a plan you'll be able to pick your own unique phone number and send messages to your contacts.
                        </span><br/>
                    </p>
                    <p v-else class="font-italic text-sm mb-3 md:mr-4 md:mb-0">
                        <span class="font-bold">
                            The trial account phone number should be used for testing only. After upgrading your account you will be able to select your own unique phone number.
                        </span>
                    </p>
                  </div>
                    <message-form key="dashboard-message-form"/>
                </div>
            </div>
        </div>

        <notification-modal
            v-if="showNotifications"
            @close="showNotifications = false"
            :notification="$page.props.notifications[0]"
        ></notification-modal>

    </app-layout>
</template>

<script>
import MessageForm from '../components/MessageForm';
import AppLayout from '../Layouts/AppLayout'
import Welcome from './../Jetstream/Welcome'
import OrganizationInfoBox from "../components/OrganizationInfoBox";
import JetButton from './../Jetstream/Button';
import notificationModal from './../components/Modals/NotificationModal';

export default {
    components: {
        MessageForm,
        AppLayout,
        Welcome,
        OrganizationInfoBox,
        JetButton,
        notificationModal
    },
    data: () => ({
        showNotifications: false,
    }),
    mounted() {
        if (this.$page.props.notifications.length) {
            this.showNotifications = true;
        }
    },
     methods: {
        formatPhoneNumber(phoneNumber) {
          // Remove any non-numeric characters from the phone number.
          phoneNumber = phoneNumber.replace(/[^0-9]/g, "");

          // Check if the phone number is 10 digits long.
          if (phoneNumber.length !== 11) {
            return null;
          }
          // Format the phone number in the (###) ###-#### format.
          return "(" + phoneNumber.substring(1, 4) + ") " + phoneNumber.substring(4, 7) + "-" + phoneNumber.substring(7);
        }
    },
    computed: {
        formattedPhoneNumber() {
            return this.$page.props.auth.user.organization.phone
            ? this.formatPhoneNumber(this.$page.props.auth.user.organization.phone)
                : null;
        }
    }
}


</script>
